import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  COUNTRY_FEATURE_KEY,
  CountryState,
  CountryPartialState,
  countryAdapter
} from './country.reducer';

// Lookup the 'Country' feature state managed by NgRx
export const getCountryState = createFeatureSelector<
  CountryPartialState,
  CountryState
>(COUNTRY_FEATURE_KEY);

const { selectAll, selectEntities } = countryAdapter.getSelectors();

export const getCountryLoaded = createSelector(
  getCountryState,
  (state: CountryState) => state.loaded
);

export const getCountryError = createSelector(
  getCountryState,
  (state: CountryState) =>  state.error
);

export const loadingCountry = createSelector(
  getCountryState,
  (state: CountryState) =>  state.loaded
);

export const getAllCountry = createSelector(
  getCountryState,
  (state: CountryState) => selectAll(state)
);

export const getCountryEntities = createSelector(
  getCountryState,
  (state: CountryState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getCountryState,
  (state: CountryState) => state.selectedCountryId
);

export const getSelected = createSelector(
  getCountryEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);
